import React from 'react';
import { Picky } from 'react-picky';
import 'react-picky/dist/picky.css';
import {
  CampaignColumnsKeys,
  CampaignColumnsKeysType,
  CampaignColumnsLabel
} from 'utils/campaigns';
import './styles.scss';
import Checkbox from 'components/Inputs/Checkbox';

const OPTIONS = [{ key: 'all', value: 'All' }].concat(
  CampaignColumnsKeys.map(key => ({ key, value: CampaignColumnsLabel[key] }))
);

interface Props {
  selected: Array<string>;
  onSelect(key: CampaignColumnsKeysType): void;
}

const ColumnsSelector: React.FC<Props> = ({ selected, onSelect }) => {
  const renderOptions = ({ items }) => {
    return (
      <div className="options-container">
        <div className="title">Table columns included</div>
        {items.map(item => (
          <Checkbox
            id={`column-selector-option-${item.key}`}
            checked={
              selected.some(key => key === item.key) ||
              selected.length === CampaignColumnsKeys.length
            }
            readonly={item.key === 'all' && selected.length === CampaignColumnsKeys.length}
            key={item.key}
            label={item.value}
            onChange={() => onSelect(item.key)}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="campaigns-column-selector">
      <Picky
        defaultFocusFilter
        valueKey="value"
        labelKey="label"
        options={OPTIONS}
        placeholder="Columns shown"
        value={[]}
        multiple
        includeSelectAll={false}
        keepOpen
        onChange={values => console.log(values)}
        // render={renderOption}
        renderList={renderOptions}
      />
    </div>
  );
};

export default ColumnsSelector;
